module.exports = __webpack_public_path__ + "static/media/VWHead-Bold.8b17530f.woff";